import { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Typography, Modal, Icon } from '@safedns/skydns-ui-react-lib';

import ModalContext from '../../contexts/modal-context';

import {
  useGetUserQuery,
  useDeleteDomainControllerMutation,
} from '../../services/ADapi';

import { notificationSuccess } from '../../store/notificationReducer';

import styles from '../../styles/deleteModal.module.scss';

import sprite from '../../icons/sprite.svg';

const DeleteDomainController = () => {
  const dispatch = useDispatch();
  const controllerToUpdate = useSelector(
    (state) => state.domainControllers.controllerToUpdate
  );
  const { isShowRemoveModal, setIsShowRemoveModal } = useContext(ModalContext);

  const {
    data: { user_id },
  } = useGetUserQuery();

  const [deleteDomainController] = useDeleteDomainControllerMutation();

  const notificationData = {
    isNotification: true,
    type: 'success',
    message: `${controllerToUpdate.name} удален`,
  };

  const onToggleModal = () => {
    return setIsShowRemoveModal(false);
  };

  const deleteCollectionHandler = async () => {
    try {
      await deleteDomainController({
        user_id,
        domainControllerId: controllerToUpdate.id,
      }).unwrap();
      dispatch(notificationSuccess(notificationData));
    } catch (error) {
      dispatch(
        notificationSuccess({
          ...notificationData,
          type: 'error',
          message: `${controllerToUpdate.name} не был удален`,
        })
      );
    }

    setIsShowRemoveModal(false);
  };

  return (
    <Modal
      isOpen={isShowRemoveModal}
      title="Удалить домен контроллер?"
      onClose={onToggleModal}
      sx={{ maxWidth: 460 }}
    >
      <div className={styles['modal-content']}>
        <div className={styles['icon-wrapper']}>
          <Icon
            id="remove"
            sprite={sprite}
            width={24}
            height={24}
            color="white"
          />
        </div>
        <Typography
          sx={{
            paddingTop: 12,
            paddingBottom: 24,
            textAlign: 'center',
            fontWeight: 500,
          }}
        >
          Вы уверены что хотите удалить домен контроллер
          <br />
          &nbsp;"{controllerToUpdate.name}"?
        </Typography>
        <div className="button-grid">
          <Button variant="secondary" onClick={onToggleModal} size="small">
            Отмена
          </Button>
          <Button
            variant="primary"
            onClick={deleteCollectionHandler}
            size="small"
          >
            Удалить
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteDomainController;
